import React from 'react'
import './CardContainer.scss'
import MDXSplitter from './MDXSplitter'


const CardContainer = ({title, children}) => {

  return (
    <div id='CardContainer'>
      {title &&
        <div className="title"><h2>{title}</h2></div>
      }
      <MDXSplitter>
        {children}
      </MDXSplitter>
    </div>
  )
}

export default CardContainer